export const GET_TRANSACTION = 'MARRIAGE_CERTIFICATES/get_transaction';
export const APPROVE_TRANSACTION = 'MARRIAGE_CERTIFICATES/approve_transaction';
export const UPDATE_TRANSACTION = 'MARRIAGE_CERTIFICATES/update_transaction';
export const SHOW_TRANSACTION = 'MARRIAGE_CERTIFICATES/show_transaction';
export const START_ASSESSMENT = 'MARRIAGE_CERTIFICATES/start_assessment';
export const GET_SETTINGS = 'MARRIAGE_CERTIFICATES/get_settings';
export const UPDATE_TEST_STATUS = 'MARRIAGE_CERTIFICATES/update_health_status';
export const GET_MARRIAGE_ARCHIVE =
  'MARRIAGE_CERTIFICATES/get_MARRIAGE_CERTIFICATES_archive';
export const GET_PHOTO = 'MARRIAGE_CERTIFICATES/getPhoto';
export const ASSESS_RECEIPT = 'MARRIAGE_CERTIFICATES/assess_receipt';
export const EDIT_MARRIAGE = 'MARRIAGE_CERTIFICATE/edit_marriage';
export const UPDATE_REGISTRY = 'MARRIAGE_CERTIFICATE/update_registry';
export const QR_VERIFIER = 'MARRIAGE_CERTIFICATE/qr_verifier';
export const MANUAL_PAYMENT_APPROVE =
  'MARRIAGE_CERTIFICATE/manual_payment_approve';
export const MANUAL_PAYMENT_REJECT =
  'MARRIAGE_CERTIFICATE/manual_payment_reject';
export const GET_LOGS = 'MARRIAGE_CERTIFICATE/get_logs';
export const APPLY_DISCOUNT = 'MARRIAGE_CERTIFICATE/apply_discount';
export const CANCEL_APPLICATION = 'MARRIAGE_CERTIFICATE/cancel_application';
export const CANCEL_ASSESSMENT = 'MARRIAGE_CERTIFICATE/cancel_assessment';
export const GET_PURPOSE_LIST = 'BIRTH_CERTIFICATE/get_purpose_list';

export const FORM_DATA = {
  // Owner's Personal Information
  husband_first_name: '',
  husband_middle_name: '',
  husband_last_name: '',
  husband_extension_name: '',
  wife_first_name: '',
  wife_middle_name: '',
  wife_last_name: '',
  wife_extension_name: '',

  // Marriage Information
  date_marriage: '',
  place_marriage_region_code: '',
  place_marriage_province_code: '',
  place_marriage_municipality_code: '',
  place_marriage_barangay_code: '',

  // Requestor's Information
  requestors_first_name: '',
  requestors_middle_name: '',
  requestors_last_name: '',
  requestors_extension_name: '',
  relationship_to_the_owner: '',

  // Mailing Address
  region_code: '',
  province_code: '',
  municipality_code: '',
  barangay_code: '',
  street: '',
  mailing_zip_code: '',
  telephone_number: '',
  mobile_number: '',

  // Transactional Information
  is_registered_late: 0,
  registered_when: '',
  number_of_copies: 0,
  what_to_print: '',
  valid_id_to_present: 'OTHER',
  purpose_code: '',
  purpose_specify: '',
  purpose_country_code: '',

  // NEED FOR VALIDATION ONLY
  mailing_address_region_code: '',
  mailing_address_province_code: '',
  mailing_address_municipality_code: '',
  mailing_address_barangay_code: '',
  mailing_address_street_code: '',
};
